import * as React from "react";
import makeStyles from "@mui/styles/makeStyles";
import {FormControl, FormLabel, Grid, TextField, RadioGroup, FormControlLabel, Radio, TextareaAutosize} from "@mui/material";
import DatePicker from "@mui/lab/DatePicker";
import {useTranslation} from "react-i18next";
import {useStylesInputControls} from "./createBookAdmissionForm";
import * as _ from "lodash";
import config from '../../app/config';

const useStyles = makeStyles((theme) => ({
    label: {
        color: theme.palette.admissionForm.labelColor,
        lineHeight: "32px",
        fontWeight: "500",
        fontSize: "0.95rem",
    },
    notesInput: {
        backgroundColor: theme.palette.background.paperDarker,
        borderColor: theme.palette.admissionForm.borderColor,
        borderRadius: "6px",
        color: theme.palette.admissionForm.textColor,
        resize: "none",
    }
}))

export const localDemographicSchema = {
    hospitalNumber: "",
    nhsNumber: "",
    dob: null,
    gender: "",
    firstName: "",
    middleNames: "",
    familyName: "",
    title: "",
    genderCode: "",
    address: ""
}

export const demographicSchema = {
    patientId: "",
    patientName: "",
    patientDob: null,
}

const demographicMapper = {
    patientId: (localDemographicSchemaObj) => {
        return localDemographicSchemaObj.hospitalNumber
    },
    patientName: (localDemographicSchemaObj) => {
        return localDemographicSchemaObj.familyName +
            (localDemographicSchemaObj.familyName ? ", " : "") +
            (localDemographicSchemaObj.firstName? localDemographicSchemaObj.firstName: "") +
            (localDemographicSchemaObj.middleNames ? ` ${localDemographicSchemaObj.middleNames}` : "")
    },
    patientDob:(localDemographicSchemaObj) => {
        return localDemographicSchemaObj.dob
    }
}

export function FromDemographicsSection(props) {
    const classes = useStyles();
    const inputClasses =  useStylesInputControls();
    const {t} = useTranslation();
    const [patient, setPatient] = React.useState(localDemographicSchema);

    React.useEffect(()=>{
        if(props.patient) {
            let p = {...localDemographicSchema};
            Object.keys(patient).forEach(patientPropKey => {
                if(patientPropKey == "address"){
                   if(props.patient.hasOwnProperty("addressLines") && props.patient.addressLines && Array.isArray(props.patient.addressLines)) {
                       p["address"] = "";
                       props.patient.addressLines.forEach(addressLine => {
                           p["address"] += `${addressLine}${String.fromCharCode(13, 10)}`;
                       })
                   }
                } else {
                    p[patientPropKey] = props.patient[patientPropKey];
                    //props.onChange(patientPropKey, props.patient[patientPropKey]);
                }
            });
            //props.onChange("address", p["address"]);
            let changes = [];
            Object.keys(demographicSchema).forEach(mapperKey => {
                changes.push([mapperKey, demographicMapper[mapperKey](p)]);
            });
            props.onChange('multiChange', changes);
            setPatient(p);
        } else {
            setPatient(localDemographicSchema);
        }
    }, [props.patient])

    const handleChange = (item, newValue) => {
        if(props.onChange && _.isFunction(props.onChange)){
            props.onChange(item, newValue);
        }
        let p = {...patient};
        p[item] = newValue;
        setPatient(p);
    }

    return (
        <Grid container>
            <Grid item xs={4} sx={{padding: "10px"}}>
                <FormControl sx={{ width: "100%"}}>
                    <FormLabel id="admission-demographic-hospital-number-label" className={inputClasses.label}>{t("Hospital number")}</FormLabel>
                    <TextField id="admission-demographic-hospital-number" value={patient?.hospitalNumber}
                               size={"small"}
                               onChange={(ev) => {
                                   handleChange("hospitalNumber", ev.target.value);
                               }}
                               disabled={true}/>
                </FormControl>
            </Grid>
            <Grid item xs={4} sx={{padding: "10px"}}>
                <FormControl sx={{ width: "100%"}}>
                    <FormLabel id="admission-demographic-nhs-number-label" className={inputClasses.label}>{t("NHS number")}</FormLabel>
                    <TextField id="admission-demographic-nhs-number"
                               size={"small"}
                               value={patient?.nhsNumber}
                               onChange={(ev) => {
                                   handleChange("nhsNumber", ev.target.value);
                               }} disabled={true}/>
                </FormControl>
            </Grid>
            <Grid item xs={4} sx={{padding: "10px"}}>
                <FormControl sx={{ width: "100%"}}>
                    <FormLabel id="admission-demographic-dob-label-" className={inputClasses.label}>{t("Date of Birth")}</FormLabel>
                    <DatePicker
                        id="admission-demographic-dob"
                        value={patient.dob}
                        onChange={(newValue) => {
                            handleChange("dob", newValue);
                        }}
                        inputFormat={config.defaultDateFormat}
                        renderInput={(params) => <TextField   size={"small"} {...params} />}
                        disabled={true}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={4} sx={{padding: "10px"}}>
                <FormControl sx={{ width: "100%"}}>
                    <FormLabel id="admission-demographic-first-name-label" className={inputClasses.label}>{t("First Name")}</FormLabel>
                    <TextField id="admission-demographic-first-name"
                               size={"small"}
                               value={patient?.firstName}
                               onChange={(ev) => {
                                   handleChange("firstName", ev.target.value);
                               }} disabled={true}/>
                </FormControl>
            </Grid>
            <Grid item xs={4} sx={{padding: "10px"}}>
                <FormControl sx={{ width: "100%"}}>
                    <FormLabel id="admission-demographic-middle-names-label" className={inputClasses.label}>{t("Middle Name")}</FormLabel>
                    <TextField id="admission-demographic-middle-names"
                               size={"small"}
                               value={patient?.middleNames}
                               onChange={(ev) => {
                                   handleChange("middleNames", ev.target.value);
                               }} disabled={true}/>
                </FormControl>
            </Grid>
            <Grid item xs={4} sx={{padding: "10px"}}>
                <FormControl sx={{ width: "100%"}}>
                    <FormLabel id="admission-demographic-surname-label" className={inputClasses.label}>{t("Surname")}</FormLabel>
                    <TextField id="admission-demographic-surname"
                               size={"small"}
                               value={patient?.familyName}
                               onChange={(ev) => {
                                   handleChange("familyName", ev.target.value);
                               }} disabled={true}/>
                </FormControl>
            </Grid>
            <Grid item xs={12} sx={{padding: "10px"}}>
                <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label"  className={inputClasses.label}>{t("Gender")}</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={patient?.genderCode}
                        onChange={(ev)=>{handleChange("genderCode", ev.target.value);}}
                    >
                        <FormControlLabel value="2" control={<Radio />} checked={patient?.genderCode == "2"} label={t("Female")} disabled={true}/>
                        <FormControlLabel value="1" control={<Radio />} checked={patient?.genderCode == "1"} label={t("Male")} disabled={true}/>
                        <FormControlLabel value="9" control={<Radio />} checked={patient?.genderCode == "9"} label={t("Unspecified")} disabled={true}/>
                        <FormControlLabel value="0" control={<Radio />} checked={patient?.genderCode == "0"} label={t("Not known")} disabled={true}/>
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs={12} sx={{padding: "10px"}}>
                <FormControl sx={{ width: "100%", marginRight: "10px" }}>
                    <FormLabel id="admission-demographic-address-label" className={inputClasses.label}>{t("Address")}</FormLabel>
                    <TextField
                        className={inputClasses.notesInput}
                        id="admission-demographic-address"
                        aria-label={t("Address")}
                        placeholder={t("Unknown")}
                        maxRows={4}
                        minRows={4}
                        multiline
                        size={"small"}
                        value={patient?.address}
                        onChange={(ev) => {
                            handleChange("address", ev.target.value);
                        }}
                        disabled={true}
                    />
                </FormControl>
            </Grid>
        </Grid>
    )
}